<template>
  <div class="table-fields w-100 mb-0 p-3">
    <div
      v-for="item in items"
      class="d-flex"
      style="gap: 1rem"
    >
      <div
        :style="options.isNewSalesforce ? 'width: 100%' : '120px'"
        class="d-flex align-items-center"
      >
        {{ item.friendlyName || getEntityName(item) }}
      </div>
      <div
        v-if="options.isDealCloud || options.isSalesforce"
        style="flex: 1"
      >
        <div
          v-if="options.isNewSalesforce"
          class="new-salesforce-inputs"
        >
          <input-widget
            :id="`isReadEnabled-${$options.filters.displayName(item.friendlyName || getEntityName(item))}-entityColumnsField`"
            :model="{isReadEnabled: item.isReadEnabled}"
            :disabled="disable"
            :field="{type: 'checkbox', label: '', name: 'isReadEnabled'}"
            @change="(val) => $emit('onCheckboxChange', {name: 'isReadEnabled', id: item.endpointId, value: val})"
          />
        </div>
        <input-widget
          v-if="!options.isNewSalesforce"
          :id="`${$options.filters.displayName(item.friendlyName || getEntityName(item))}-entityColumnsField`"
          :disabled="disable"
          :field="{...options.isDealCloud ? DealCloudColumnsToUpdate : SalesforceColumnsToPull, data: {options: getPullColumnsForEndpoint(item)}}"
          :model="JSON.parse(item.endpointConfigurationJSON) || {}"
          @select="onSelectColumn($event, item)"
        />
      </div>
      <div
        v-if="options.isSalesforce && !options.isNewSalesforce"
        style="flex: 1"
      >
        <input-widget
          :id="`${$options.filters.displayName(item.friendlyName || getEntityName(item))}-entityColumnsToUpdateField`"
          :disabled="disable"
          :field="{...SalesforceColumnsToUpdate, data: {options: getUpdateColumnsForEndpoint(item)}}"
          :model="JSON.parse(item.endpointConfigurationJSON) || {}"
          @select="onUpdateColumnSelect($event, item)"
        />
      </div>
      <div
        class="d-flex align-items-center"
        style="text-align: right"
      >
        <div class="d-flex float-right">
          <b-button
            v-if="actionButtons.update"
            :id="`${$options.filters.displayName(item.friendlyName || getEntityName(item))}-update`"
            size="sm"
            variant="outline-primary"
            class="ml-1 action-button"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Update external system"
            @click="onUpdate(item)"
          >
            <font-awesome-icon :icon="['fas', 'arrow-up']" />
          </b-button>
          <b-button
            v-if="isEndpoint && actionButtons.preview"
            :id="`${$options.filters.displayName(item.friendlyName || getEntityName(item))}-preview`"
            :disabled="disable"
            size="sm"
            variant="outline-warning"
            class="ml-1 action-button"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Preview"
            @click="onPreviewClick(item)"
          >
            <font-awesome-icon :icon="['fas', 'eye']" />
          </b-button>
          <b-button
            v-if="actionButtons.save"
            :id="`${$options.filters.displayName(item.friendlyName || getEntityName(item))}-save`"
            size="sm"
            variant="outline-success"
            class="ml-1 action-button"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Generate"
            @click="onSaveClick(item)"
          >
            <font-awesome-icon :icon="['far', 'save']" />
          </b-button>
          <b-button
            v-if="actionButtons.edit"
            :id="`${$options.filters.displayName(item.friendlyName || getEntityName(item))}-edit`"
            :disabled="disable"
            size="sm"
            variant="outline-primary"
            class="ml-1 action-button"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Edit"
            @click="onEditClick(item)"
          >
            <font-awesome-icon :icon="['fas', 'edit']" />
          </b-button>
          <b-button
            v-if="actionButtons.delete"
            :id="`${$options.filters.displayName(item.friendlyName || getEntityName(item))}-delete`"
            size="sm"
            variant="outline-danger"
            class="ml-1 action-button"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Delete"
            @click="onDeleteClick(item)"
          >
            <font-awesome-icon :icon="['fas', 'trash']" />
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputWidget from '../../../core/components/complex-table/components/InputWidget';
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('connectorScreen');
export default {
  name: 'ConnectorPointsTable',
  components: {InputWidget},
  props: {
    items: {
      type: [Object, Array],
      required: true,
    },
    isEndpoint: {
      type: Boolean,
      default: false,
    },
    actionButtons: {
      type: Object,
      default: () => ({
        preview: true,
        save: true,
        edit: true,
        delete: true,
      }),
    },
    options: {
      type: Object,
    },
  },
  data() {
    return {
      DealCloudColumnsToUpdate: {
        type: 'multi-select',
        required: false,
        name: 'DealCloudColumnsToUpdate',
        config: {
          placeholder: 'Select columns',
          multiple: true,
          taggable: false,
        },
        data: {
          options: [],
        },
      },
      SalesforceColumnsToPull: {
        type: 'multi-select',
        required: false,
        name: 'SalesforceColumnsToPull',
        config: {
          placeholder: 'Columns to Pull',
          multiple: true,
          taggable: false,
        },
        data: {
          options: [],
        },
      },
      SalesforceColumnsToUpdate: {
        type: 'multi-select',
        required: false,
        name: 'SalesforceColumnsToUpdate',
        config: {
          placeholder: 'Columns to Update',
          multiple: true,
          taggable: false,
        },
        data: {
          options: [],
        },
      },
    };
  },
  computed: {
    ...mapState({
      disable: state => state.disableDuringRequest,
    }),
  },
  methods: {
    onPreviewClick(item) {
      this.$emit('on-preview-click', item);
    },
    onSaveClick(item) {
      this.$emit('on-save-click', item);
    },
    onEditClick(item) {
      this.$emit('on-edit-click', item, this.isEndpoint);
    },
    onUpdate(item) {
      this.$emit('on-update', item);
    },
    onDeleteClick(item) {
      this.$emit('on-delete-click', item, this.isEndpoint);
    },
    getEntityName(item) {
      if (this.options.isNewSalesforce) {
        return item.endpointName;
      } else {
        const endpointConfigurationJSON = item.endpointConfigurationJSON ? JSON.parse(item.endpointConfigurationJSON) : {};
        return this.options.EntityNames && this.options.EntityNames[item.entityName] || item.entityName || endpointConfigurationJSON.tableName;
      }
    },
    onSelectColumn(options, item) {
      if (!this.options.isNewSalesforce) {
        const columnsData = JSON.parse(item.endpointConfigurationJSON) || {};
        if (this.options.isDealCloud) {
          columnsData.DealCloudColumnsToUpdate = options;
        } else {
          columnsData.SalesforceColumnsToPull = options;
          columnsData.SalesforceColumnsToUpdate = (columnsData.SalesforceColumnsToUpdate || []).filter(c => options.includes(c));
        }

        item.endpointConfigurationJSON = JSON.stringify(columnsData);
        this.$emit('update-endpoint', item);
      }
    },
    onUpdateColumnSelect(options, item) {
      if (!this.options.isNewSalesforce) {
        const columnsData = JSON.parse(item.endpointConfigurationJSON) || {};

        if (this.options.isDealCloud) {
          columnsData.DealCloudColumnsToUpdate = options;
        } else {
          columnsData.SalesforceColumnsToUpdate = options;
        }

        item.endpointConfigurationJSON = JSON.stringify(columnsData);
        this.$emit('update-endpoint', item);
      }
    },
    getPullColumnsForEndpoint(item) {
      return this.options.endpointEntryColumns[item.endpointId] || [];
    },
    getUpdateColumnsForEndpoint(item) {
      const columnsToUpdate = this.options.endpointEntryColumns[item.endpointId] || [];
      if (!this.options.isDealCloud && !this.options.isNewSalesforce) {
        const tmpColumns = JSON.parse(item.endpointConfigurationJSON || '{}').SalesforceColumnsToPull || [];
        return columnsToUpdate.filter(c => tmpColumns.includes(c));
      }

      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.table-fields {
  & > div {
    height: 44px;
    padding: 0 12px;

    &:nth-child(odd) {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
}
</style>
